module.exports = __webpack_public_path__ + "static/Anschlussschlauc-PIO2000-90-52a4a3de8a96a3e5bc250655d9153123.jpg";